import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { AdditionalCardSettings } from "Payments/AddPaymentMethod";
import { usePaymentMethodState } from "Payments/AddPaymentMethod";
import CardErrorMessages from "Payments/ManagePaymentMethods/AddPaymentMethodModal/CardErrors";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { AnimatePresence, motion } from "framer-motion";

import { usePaymentTypeVerbiage } from "Utilities/Hooks/usePaymentTypeVerbiage";

import SubmitButtons from "./SubmitButtons";

export default function AdditionalSettings({
  inputErrors,
  setInputErrors,
  setShouldClearDisplayMessages,
  hasMobilePhone,
  sharableWith,
  goBack,
  defaultOpen = false,
  networkName,
}) {
  const { mustSaveCard, isAlreadyExisting } = usePaymentMethodState();
  const {
    state: { currentScreen },
  } = usePaymentPage();

  const [showAdditionalSettings, setShowAdditionalSettings] = useState(
    isAlreadyExisting || defaultOpen
  );

  const fundSettingPaymentType =
    window.data?.paymentPageData?.fund?.paymentPageSettings?.paymentType ||
    null;
  const { leadText } = usePaymentTypeVerbiage(fundSettingPaymentType);

  return (
    <AdditionalSettingsAndSaveContainer>
      <CardErrorMessages inputErrors={inputErrors} />
      <AdditionalSettingsContainer>
        <AnimatePresence initial={!isAlreadyExisting}>
          {showAdditionalSettings && (
            <motion.div
              key="settings"
              initial={{
                height: 0,
                opacity: 0,
                scale: mustSaveCard || isAlreadyExisting ? 0.8 : 1,
              }}
              animate={{
                opacity: 1,
                height: "auto",
                scale: 1,
                transition: { delay: 0.05 },
              }}
            >
              <AdditionalCardSettings
                hasMobilePhone={hasMobilePhone}
                sharableWith={sharableWith}
                networkName={networkName}
                leadText={leadText}
                currentScreen={currentScreen}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </AdditionalSettingsContainer>
      <SubmitButtons
        showAdditionalSettings={showAdditionalSettings}
        setShowAdditionalSettings={setShowAdditionalSettings}
        setInputErrors={setInputErrors}
        setShouldClearDisplayMessages={setShouldClearDisplayMessages}
        goBack={goBack}
      />
    </AdditionalSettingsAndSaveContainer>
  );
}

const AdditionalSettingsAndSaveContainer = styled(motion.div)`
  padding-top: 14px;
`;

const AdditionalSettingsContainer = styled.div`
  position: relative;
`;
